// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".o-confirmation-summary__information[data-v-174ffa89]{margin-bottom:20px}.o-confirmation-summary__requirements[data-v-174ffa89]{margin-bottom:20px;border:1px solid #e8e8e8}.o-confirmation-summary__item[data-v-174ffa89]{margin-bottom:36px}@media (max-width:767px){.o-confirmation-summary__item[data-v-174ffa89]{margin-bottom:30px}}.o-confirmation-summary__caption[data-v-174ffa89]{margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
